import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-71dcce54")

_pushScopeId("data-v-71dcce54")
const _hoisted_1 = { class: "carInfo" }
const _hoisted_2 = {
  key: 0,
  class: "carInfo_card"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "ui__comTitle_main bgBlue" }, [
  /*#__PURE__*/_createVNode("div", { class: "ui__comTitle_left" }, "车辆信息"),
  /*#__PURE__*/_createVNode("span", { class: "titleSlot" }, "*车型信息仅供参考，请以实车为准")
], -1)
const _hoisted_4 = { class: "infoList_main" }
const _hoisted_5 = { class: "infoList_item_value" }
const _hoisted_6 = {
  key: 0,
  class: "infoList_item_value_txt"
}
const _hoisted_7 = {
  key: 1,
  class: "infoList_item_value_txt"
}
const _hoisted_8 = { class: "infoList_item_label" }
const _hoisted_9 = /*#__PURE__*/_createVNode("i", null, null, -1)
const _hoisted_10 = {
  key: 1,
  class: "carInfo_card"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "ui__comTitle_main bgGreen" }, [
  /*#__PURE__*/_createVNode("div", { class: "ui__comTitle_left" }, "三电基本信息")
], -1)
const _hoisted_12 = { class: "infoList_main" }
const _hoisted_13 = { class: "infoList_item_value" }
const _hoisted_14 = {
  key: 0,
  class: "infoList_item_value_txt"
}
const _hoisted_15 = {
  key: 1,
  class: "infoList_item_value_txt"
}
const _hoisted_16 = { class: "infoList_item_label" }
const _hoisted_17 = /*#__PURE__*/_createVNode("i", null, null, -1)
const _hoisted_18 = {
  key: 2,
  class: "carInfo_card"
}
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "ui__comTitle_main" }, [
  /*#__PURE__*/_createVNode("div", { class: "ui__comTitle_left" }, "配置信息"),
  /*#__PURE__*/_createVNode("span", { class: "titleSlot" }, "*配置信息仅供参考，请以实车为准")
], -1)
const _hoisted_20 = { class: "infoList_main" }
const _hoisted_21 = { class: "infoList_item_value" }
const _hoisted_22 = {
  key: 0,
  class: "infoList_item_value_txt"
}
const _hoisted_23 = {
  key: 1,
  class: "infoList_item_value_txt"
}
const _hoisted_24 = { class: "infoList_item_label" }
const _hoisted_25 = /*#__PURE__*/_createVNode("i", null, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.state.baseInfo && _ctx.state.baseInfo.length > 0)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode("div", _hoisted_4, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.baseInfo, (item, index) => {
              return (_openBlock(), _createBlock("div", {
                class: "infoList_item",
                key: item.code
              }, [
                _createVNode("div", _hoisted_5, [
                  (item.value)
                    ? (_openBlock(), _createBlock("div", _hoisted_6, [
                        _createVNode("div", {
                          class: ["infoTxt", {'noHidden': item.code==='VIN'}],
                          onClick: _withModifiers(($event: any) => (_ctx.changePopoverState(item)), ["stop"])
                        }, _toDisplayString(item.value), 11, ["onClick"])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_7, "-"))
                ]),
                _createVNode("div", _hoisted_8, [
                  _createTextVNode(_toDisplayString(item.name) + " ", 1),
                  _withDirectives(_createVNode("div", {
                    class: ["popover", _ctx.setClass(index)]
                  }, [
                    _hoisted_9,
                    _createTextVNode(_toDisplayString(item.value), 1)
                  ], 2), [
                    [_vShow, item.showPopover]
                  ])
                ])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.state.batteryBaseInfo && _ctx.state.batteryBaseInfo.length > 0)
      ? (_openBlock(), _createBlock("div", _hoisted_10, [
          _hoisted_11,
          _createVNode("div", _hoisted_12, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.batteryBaseInfo, (item, index) => {
              return (_openBlock(), _createBlock("div", {
                class: "infoList_item",
                key: item.code
              }, [
                _createVNode("div", _hoisted_13, [
                  (item.value)
                    ? (_openBlock(), _createBlock("div", _hoisted_14, [
                        _createVNode("div", {
                          class: "infoTxt",
                          onClick: _withModifiers(($event: any) => (_ctx.changePopoverState(item)), ["stop"])
                        }, _toDisplayString(item.value), 9, ["onClick"])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_15, "-"))
                ]),
                _createVNode("div", _hoisted_16, [
                  _createTextVNode(_toDisplayString(item.name) + " ", 1),
                  _withDirectives(_createVNode("div", {
                    class: ["popover", _ctx.setClass(index)]
                  }, [
                    _hoisted_17,
                    _createTextVNode(_toDisplayString(item.value), 1)
                  ], 2), [
                    [_vShow, item.showPopover]
                  ])
                ])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.state.configInfo && _ctx.state.configInfo.length > 0)
      ? (_openBlock(), _createBlock("div", _hoisted_18, [
          _hoisted_19,
          _createVNode("div", _hoisted_20, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.configInfo, (item, index) => {
              return (_openBlock(), _createBlock("div", {
                class: "infoList_item",
                key: item.code
              }, [
                _createVNode("div", _hoisted_21, [
                  (item.value)
                    ? (_openBlock(), _createBlock("div", _hoisted_22, [
                        _createVNode("div", {
                          class: "infoTxt",
                          onClick: _withModifiers(($event: any) => (_ctx.changePopoverState(item)), ["stop"])
                        }, _toDisplayString(item.value), 9, ["onClick"])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_23, "-"))
                ]),
                _createVNode("div", _hoisted_24, [
                  _createTextVNode(_toDisplayString(item.name) + " ", 1),
                  _withDirectives(_createVNode("div", {
                    class: ["popover", _ctx.setClass(index)]
                  }, [
                    _hoisted_25,
                    _createTextVNode(_toDisplayString(item.value), 1)
                  ], 2), [
                    [_vShow, item.showPopover]
                  ])
                ])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})